export type BlueprintOverheadDimensionsToggleProps = {
	hidden: boolean;
	onToggle: () => void;
};

// Stacks below BlueprintPageFontControl's control, off the page's top-right corner.
const CONTROL_STYLE: React.CSSProperties = {
	position: 'absolute',
	left: '100%',
	marginLeft: '12px',
	top: '90px',
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	padding: '4px 8px',
	backgroundColor: 'rgba(255,255,255,0.95)',
	border: '1px solid #ccc',
	borderRadius: '4px',
	fontFamily: "'Inter', sans-serif",
	fontSize: '11px',
	color: '#333',
	boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
	userSelect: 'none',
	whiteSpace: 'nowrap',
	cursor: 'pointer',
	zIndex: 5
};

/**
 * Small, persisted checkbox letting a designer hide the two overall (kitchen-wide)
 * width/depth dimension lines on the Overhead Layout sheet -- GitHub #450. State and
 * persistence (kitchen.blueprintOverrides) are owned by BlueprintOverheadLayoutPage,
 * same reasoning as BlueprintPageFontControl: the blueprint-view tree deliberately
 * does not subscribe to ('kitchen','updated'), so a control that only read the
 * kitchen model would never see its own write reflected. Excluded from the PDF/PPTX
 * export via data-html2canvas-ignore.
 */
export const BlueprintOverheadDimensionsToggle = (props: BlueprintOverheadDimensionsToggleProps): React.ReactElement => {
	const { hidden, onToggle } = props;

	return (
		<label style={CONTROL_STYLE} data-html2canvas-ignore="true" title="Hide the two overall overhead dimension lines on this sheet">
			<input type="checkbox" checked={hidden} onChange={onToggle} style={{ margin: 0 }} />
			Hide overhead dims
		</label>
	);
};
